<template>
  <v-hover v-slot:default="{ hover }">
    <div class="py-0 my-0">
      <v-row no-gutters align="start">
        <v-col cols="1">
          <v-icon large color="grey">mdi-account-circle</v-icon>
        </v-col>
        <v-col cols="11">
          <v-row no-gutters align="center">
            <span class="text-body-2 font-weight-medium">{{ attachment.user }}</span>
            <v-spacer></v-spacer>
            <v-tooltip top v-if="hover && canEdit">
              <template v-slot:activator="{ on }">
                <v-icon
                  small
                  icon
                  color="primary"
                  v-on="on"
                  @click="edit"
                >mdi-pencil</v-icon>
              </template>
              <span>{{ $t('Edit') }}</span>
            </v-tooltip>
            <v-tooltip top v-if="hover && canDelete">
              <template v-slot:activator="{ on }">
                <v-icon
                  small
                  icon
                  color="red"
                  class="ml-1"
                  v-on="on"
                  @click="remove"
                >mdi-delete</v-icon>
              </template>
              <span>{{ $t('Delete') }}</span>
            </v-tooltip>
            <v-tooltip top v-if="canDownload">
              <template v-slot:activator="{ on }">
                <v-icon
                  small
                  icon
                  color="grey"
                  class="ml-1"
                  v-on="on"
                  @click="download"
                >mdi-download</v-icon>
              </template>
              <span>{{ $t('Download') }}</span>
            </v-tooltip>
            <v-tooltip top v-if="attachment.canDisplay">
              <template v-slot:activator="{ on }">
                <v-icon
                  small
                  icon
                  color="green"
                  class="ml-1"
                  v-on="on"
                  @click="display"
                >mdi-magnify</v-icon>
              </template>
              <span>{{ $t('View') }}</span>
            </v-tooltip>

            <span class="text-caption grey--text ml-2">{{ attachment.date }}</span>
          </v-row>

          <v-row no-gutters>
            <v-col>
              <div class="text-body-2">{{ attachment.description }}</div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-divider class="my-1" />
    </div>
  </v-hover>
</template>

<script>

import AttachmentService from '@/services/AttachmentService';

export default {
    props: {
        attachment: {
            type: Object
        },
        canEdit: {
            type: Boolean,
            default: true,
        },
        canDelete: {
            type: Boolean,
            default: true,
        },
        canDownload: {
            type: Boolean,
            default: true,
        },
    },
    methods: {
        edit() {
            this.$emit('on-edit-attachment', this.attachment);
        },
        display() {
            this.$emit('on-display-attachment', this.attachment);
        },
        remove() {
            this.$emit('on-remove-attachment', this.attachment.id);
        },
        download() {
            AttachmentService.download(this.attachment.id);
        },
    }
};
</script>